export default function Embed() {
  return (
    <iframe
      title="Borrower Signup"
      src="http://localhost:3000/register/capsource"
      width="480px"
      height="640px"
    />
  );
}
